<template>
  <div class="text-input" :class="{ hasError: error || errorMessages.length > 0 }">
    <v-text-field
      v-model="modelValue"
      :label="displayName"
      v-bind="$attrs"
      v-validate="validations"
      :error="errorMessages > 0"
      :hide-details="true"
      :data-vv-as="displayName"
      :data-vv-name="inputIdentifier"
      :id="`input_${inputIdentifier}`"
      :name="inputIdentifier"
      v-on:blur="$emit('blur', $event.target.value)"
      flat
      box
      ref="text-input-common" />
  </div>
</template>

<script>
const nonCharacterRegex = /([^a-z0-9])/g;
const duplicatedHyphensRegex = /-+/g;
const startEndHyphensRegex = /(^-)|(-$)/g;
const capitalCharacterRegex = /([A-Z])/g;

export default {
  inject: ['$validator'],
  props: {
    displayName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      default: '',
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: [Boolean],
      default: false,
    },
  },
  computed: {
    errorMessages() {
      return (this.errors && this.errors.collect)
        ? this.errors.collect(this.inputIdentifier)
        : [];
    },
    inputIdentifier() {
      if (this.identifier) {
        return this.identifier;
      }

      return this.displayName
        .replace(capitalCharacterRegex, '-$1')
        .toLowerCase()
        .replace(nonCharacterRegex, '-')
        .replace(duplicatedHyphensRegex, '-')
        .replace(startEndHyphensRegex, '');
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.v-input {
  overflow: hidden;
}

.v-input--is-focused {
  box-shadow: 0 0 1px  $theme-color-primary;
  border: 1px solid $theme-color-primary;
}

::v-deep .v-text-field__details {
  display: none;
}

::v-deep input {
  border: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 1rem;
  padding: 10px 15px 10px 0px;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
}

.hasError {
  label {
    color: $theme-color-alert;
  }

  .v-input {
    border: 1px solid rgba($theme-color-alert, 0.5);
  }

  ::v-deep input {
    color: $theme-color-alert;
  }

  ::v-deep .v-label {
    color: $theme-color-alert;
  }
}
</style>
